import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {VerificaStatoConservazioneComponent} from './verifica-stato-conservazione';


let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.verifica-stato-conservazione', {
      url: '/verifica-stato-conservazione/:userId',
      ncyBreadcrumb: {
        label: 'Verifica stato conservazione',
        parent: 'home.conservazione',
      },
      params: {
        userId: ''
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Verifica stato conservazione',
      },
      'views': {
        'homeContent': {
          template: '<verifica-stato-conservazione flex="100"></verifica-stato-conservazione>'
        }
      }
    });

};
stateConfig.$inject = ['$stateProvider'];

export const VerificaStatoConservazioneModule: string = ng
  .module('verifica-stato-conservazione', ['ui.bootstrap', uiRouter])
  .component('verificaStatoConservazione', VerificaStatoConservazioneComponent)
  .config(stateConfig)
  .name;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/verifica-stato-conservazione/verifica-stato-conservazione.module.ts